export const ROUTES = {
  ROOT: '/',
  SIGNIN: '/signin',
  SIGNUP: '/signup',
  TODO: '/todo',
};
